import { parseRupees } from '@tailoring-crm/shared';

/**
 * Rupees typed at a counter, in paise.
 *
 * The ONE conversion the payroll screen is allowed to do, and it goes in this direction only:
 * a string a person typed into a dialog, turned into the integer the request body carries.
 * Anything unparseable is zero, which is refused before a request is built — the same guard
 * `staff-payout-page.tsx` uses, kept identical on purpose.
 */
export function safeRupees(value: string): number {
  try {
    return value.trim() === '' ? 0 : parseRupees(value);
  } catch {
    return 0;
  }
}
